import { computed, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Role } from '../enums';
import { filter } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';
import { ADMIN_COCKPIT_PATH, CYBERSECURITY_COCKPIT_PATH, PARTNER_COCKPIT_PATH } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class CockpitService {
  private readonly navigationEnd = toSignal(
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)),
    { initialValue: null },
  );

  readonly cockpitType = computed(() => {
    this.navigationEnd();
    return this.detectCockpitFromUrl();
  });

  readonly isAdmin = computed(() => this.cockpitType() === Role.GlobalAdmin);
  readonly isCustomer = computed(() => this.cockpitType() === Role.User);
  readonly isPartner = computed(() => this.cockpitType() === Role.Partner);

  readonly cockpitTypeName = computed(() => {
    switch (this.cockpitType()) {
      case Role.GlobalAdmin:
        return 'admin';
      case Role.Partner:
        return 'partner';
      case Role.User:
        return 'customer';
      default:
        return 'unknown';
    }
  });

  constructor(private readonly router: Router) {}

  private detectCockpitFromUrl(): Role {
    const segments = window.location.pathname.split('/').filter((s) => s.length > 0);

    const first = segments[0]?.toLowerCase();
    switch (first) {
      case 'admin':
      case ADMIN_COCKPIT_PATH:
        return Role.GlobalAdmin;
      case 'partner':
      case PARTNER_COCKPIT_PATH:
        return Role.Partner;
      case 'customer':
      case CYBERSECURITY_COCKPIT_PATH:
        return Role.User;
      default:
        return Role.User;
    }
  }
}
